

import httpbaseURL from '../../../../modules/Inventory/common/axios';
class DepreciationMethodMasterServices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/DepreciationMethodMaster/Create", doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/DepreciationMethodMaster/Update", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/DepreciationMethodMaster/DepreciationMethodsList")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/DepreciationMethodMaster/Get?id=" + doc)
    }

    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/DepreciationMethodMaster/Delete?id=" + doc)
    }
    active(DelID, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "/DepreciationMethodMaster/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
}
export default new DepreciationMethodMasterServices()